






















import { sortBy } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { Auth } from 'aws-amplify'

import { $db } from '@/services/Db'

import EditableTable from '@/components/EditableTable.vue'
import FirmwareForm from './FirmwareForm.vue'
import Downloader from '@/components/Downloader.vue'

@Component({ components: { EditableTable, FirmwareForm, Downloader } })
export default class FirmwarePage extends Vue {

	req = { loading: true, errors: [] }
	firmware: any[] = []
	products: any[] = []
	subs: Array<{ unsubscribe: () => void }> = []

	columns = ['id', 'PartNumVersion', 'SKU', 'type', 'ShortDescription', 'Live']

	editing = null
	newSymbol = Symbol('New Firmware')

	created() {
		this.req.loading = true
		const fields = `
			id
			type
			SKU
			Device
			ReleaseDate
			ReleaseVersion
			ReleaseApp
			ReleaseLoader
			ReleaseFont
			ReleaseScreen
			MinHardwareVersion
			MaxHardwareVersion
			ArchiveName
			ShortDescription
			LongDescription
			Live
			PartNumVersion
		`
		const firmware = $db.subscribe('firmware', 'Firmware', fields, this, 'firmware')
		const products = $db.subscribe('products', 'Product', 'id', this, 'products')

		this.subs = [firmware.subscription, products.subscription]

		Promise.all([firmware.data, products.data])
			.then(([initialFirmware, initialProducts]) => {
				this.firmware = initialFirmware
				this.products = initialProducts
			})
			.catch(err => this.req.errors = Array.isArray(err.errors) ? err.errors.map(e => e.message) : [err.message])
			.finally(() => this.req.loading = false)
	}

	destroyed() {
		this.subs.forEach(sub => sub.unsubscribe())
	}
	

}
